
module.directive('checkboxArray', function() {
    return {
        restrict: 'A',
        require: 'ngModel',
        controller: function($scope, $element) {
            var checkboxes = {}, keys={}, self=this;
            var ngModel = $element.inheritedData('$ngModelController');


            this.keyInModel = function(key) {
                return angular.isArray(ngModel.$viewValue) &&
                    ngModel.$viewValue.indexOf(key) >= 0;
            };

            this.setChecked = function(key, isChecked) {
                if (angular.isUndefined(checkboxes[key])) return;
                checkboxes[key].$setViewValue(isChecked);
                checkboxes[key].$render();
            };

            this.register = function(key, checkbox) {
                checkboxes[key] = checkbox;
                keys[key] = key;
                this.setChecked(key, this.keyInModel(key));
                checkbox.$viewChangeListeners.push(this.update.bind(this));
            };

            this.update = function() {
                var data = [];
                for (var key in checkboxes) {
                    if(checkboxes[key].$viewValue) {
                        data.push(keys[key]);
                    }
                }
                ngModel.$setViewValue(data);
            };

            ngModel.$isEmpty = function(value) {
                return !angular.isArray(value) || value.length === 0;
            };
        },
    };
});


module.directive('checkboxArrayKey', function() {
    return {
        restrict: 'A',
        require: ['^checkboxArray', 'ngModel'],
        link: function(scope, element, attrs, ctrls) {
            var key= attrs.checkboxArrayKey;
            if (/^\d+$/.test(key)) {
                key = parseInt(key);
            }
            ctrls[0].register(key, ctrls[1]);
        },
    };
});